import React from 'react';
import { DISCLAIMER } from '../data/judo';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-122" data-mp="3gf94guwt048f">
      <div className="mx-auto max-w-6xl" data-id="element-123" data-mp="3ghc486nrdbqc">
        <p className="font-serif text-3xl tracking-tight" data-id="element-124" data-mp="32oni2w855c5s">
          JUDO GOTOWE<span className="align-super text-[0.5em]" data-id="element-125" data-mp="36pfsvtwnvp46">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-126" data-mp="36ppj9ilmbyae">
          JUDO GOTOWE™ to niezależny materiał dla trenerów judo dzieci i młodzieży. {DISCLAIMER}
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-127" data-mp="387e5ix8d5do">
          © 2026 JUDO GOTOWE™. Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}